import React, { useEffect, useState } from "react";
import { colors, firebaseCredentials } from "../../../share/constants/enums";
import Button from "../../../components/common/button";
import { Link } from "react-router-dom";
import YupupScreen from "./../../../assets/icons/blackLogo.svg";
import background from "./../../../assets/icons/login-new-screen.svg";
import laptop from "./../../../assets/icons/laptop-login.svg";
import { Divider, Form, Input as InputField, message } from "antd";
import Checkbox from "../../../components/common/checkBox";
import { ReactComponent as EmailIcon } from "./../../../assets/icons/email-icon.svg";
import { ReactComponent as PasswordIcon } from "./../../../assets/icons/password-lock.svg";
import { login } from "../../../api/auth";
import { getBusiness, getUser } from "../../../api/business";
import { getToken } from "@firebase/messaging";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setFCMToken } from "../../../store/slices/userSlice";
import { getFirebaseMessaging } from "../../../firebase/firebase";
import { clearLocalStorage } from "../../../share/utils";

const Login = () => {
  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const userFcmToken = useSelector((state) => state?.user);
  const dispatch = useDispatch();

  useEffect(() => {
    const initFirebase = async () => {
      const messaging = await getFirebaseMessaging();

      if (messaging) {
        const requestPermission = async () => {
          try {
            const permission = await Notification?.requestPermission();
            if (permission === "granted") {
              const requestForToken = () => {
                return getToken(messaging, {
                  vapidKey: process.env.REACT_APP_VAPID_KEY,
                })
                  .then((currentToken) => {
                    if (currentToken) {
                      dispatch(setFCMToken(currentToken));
                    } else {
                    }
                  })
                  .catch((err) => { });
              };
              requestForToken();
            }
          } catch (error) { }
        };
        requestPermission();
      }
    };

    initFirebase();

    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get("accessToken");
    const refreshToken = urlParams.get("refreshToken");
    const businessId = urlParams.get("businessId");
    const userId = urlParams.get("userId");
    const email = urlParams.get("email");

    if (accessToken && businessId) {
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("businessId", businessId);
      localStorage.setItem("userId", userId);
      localStorage.setItem("email", email.toString());
      const handleApi = async () => {
        const userRole = await getBusiness();
        message.success("Login Successful");
        navigate("/main/home");
      };
      handleApi();
    }
  }, []);

  const onFinish = async (values) => {
    setLoader(true);

    try {
      const payload = { email: values.email, password: values.password };
      if (userFcmToken?.fcmToken) {
        payload.fcmToken = userFcmToken?.fcmToken;
      }
      const res = await login(payload);
      if (res) {
        setLoader(true);
        const isSetup = await getBusiness();
        const userRole = await getUser();
        localStorage.setItem("businessId", isSetup._id);
        localStorage.setItem("email", values.email);
        if (
          isSetup?.isApproved &&
          isSetup?.isSetup &&
          (userRole.role === "BUSINESS_OWNER" || "BUSINESS_MEMBER")
        ) {
          message.success("Login Successful");
          navigate("/main/home");
        } else if (isSetup?.isApproved === false) {
          clearLocalStorage();
          navigate("/thank-you-for-waiting");
        } else if (isSetup?.isSetup === false) {
          navigate("/invite");
        } else {
          message.error("Unauthorized");
          clearLocalStorage();
          navigate("/login");
        }
      }
    } catch (error) {
      if (error.response?.data?.message === "Password change required") {
        localStorage.setItem("inviteEmail", values.email);
        message.error(error.response?.data?.message);
        navigate("/new-password-for-invite");
      } else {
        message.error(error.response?.data?.message);
      }
    } finally {
      setLoader(false);
    }
  };

  const onFinishFailed = () => { };

  return (
    <div className="grid h-screen lg:grid-cols-2 lg:gap-4 overflow-y-hidden">
      <div className="hidden lg:block h-screen pt-1 pl-2 rounded-xl relative">
        <img
          src={background}
          alt="bg"
          className="object-cover h-[97%] w-full rounded-xl"
        />
        <img
          src={laptop}
          alt="laptop"
          className="absolute left-[12%] top-[15%] h-[300px] 2xl:left-[25%]"
        />
        <div className="absolute text-white top-[50%] text-center">
          <p className="text-[38px] font-bold ">
            Grow with YupUp: Your Journey to Success Starts Here
          </p>
          <p className="text-center px-3 font-light text-[22px]">
            Join us as an approved vendor on YupUp and experience the power of a
            partnership designed for growth. Together, we’ll amplify your
            business, attract loyal customers, and showcase your best deals. At
            YupUp, we’re not just about transactions—we’re about building
            strong, lasting relationships that fuel your success. Let’s make
            something great happen together!
          </p>
        </div>
      </div>
      <div className="lg:py-8 lg:leading-4 m-auto">
        <div className="flex lg:justify-start justify-center">
          <img className="h-9 " alt="yupup-logo" src={YupupScreen} />
        </div>
        <p className="text-[25px] lg:text-[34px] font-bold mb-1 mt-2">
          Login To Your Account
        </p>
        <p className="font-light text-[14px] lg:text-[18px] mb-4">
          Sign In As A Business
        </p>
        <Form
          form={form}
          name="signin"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                message: "The input is not valid email!",
              },
              {
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <InputField
              prefix={<EmailIcon className="mr-1" />}
              className={"w-31 h-5.4 lg:w-40 rounded-2xl pl-1"}
              placeholder="Email"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
            ]}
          >
            <InputField.Password
              prefix={<PasswordIcon className="mr-1" />}
              className={"w-31 h-5.4 rounded-2xl lg:w-40"}
              placeholder="Password"
            />
          </Form.Item>
          <div className="flex w-31 justify-between lg:w-40">
            <Form.Item name="remember">
              <Checkbox
                fontColor={"font-light text-black"}
                onChecked={() => { }}
                description="Remember me"
              />
            </Form.Item>
            <Link to="/forgot-password" className="no-underline">
              <p className="text-primaryPurple text-base font-medium	">
                Forgot Password?
              </p>
            </Link>
          </div>
          <Form.Item>
            <Button
              loading={loader}
              title="Login"
              color={colors.primaryPurple}
              className="w-31 lg:w-40 text-[20px]"
              htmlType="submit"
            />
          </Form.Item>
          <div className="w-14 lg:w-19 flex items-center">
            <Divider />
            <span className="text-black text-opacity-50 px-0.4">or</span>
            <Divider />
          </div>
        </Form>

        <p className="text-black">
          Don't have an account?
          <Link to="/signup" className="no-underline">
            <span className="text-primaryPurple font-medium ml-1">
              Create Account
            </span>
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
